import { polymorphic } from '../../utils/index.js';
export const MenuExtraContent = polymorphic.li('iui-menu-content', {
  role: 'presentation',
});
MenuExtraContent.displayName = 'MenuExtraContent';
